<div class="sensitive-currency" [class.is-invalid-wrap]="invalid" [class.display-only]="displayOnly">
  <ng-container *ngIf="displayOnly; else inputMode">
    <span class="sensitive-value" [attr.title]="revealed ? formatted : 'Valor oculto'">
      {{ revealed ? formatted : maskedLabel }}
    </span>
    <button
      type="button"
      class="btn-eye"
      (click)="toggle($event)"
      [attr.aria-label]="revealed ? 'Ocultar valor' : 'Visualizar valor'"
      [title]="revealed ? 'Ocultar valor' : 'Visualizar valor'">
      <i class="fas" [ngClass]="revealed ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
    </button>
  </ng-container>

  <ng-template #inputMode>
    <div class="input-group">
      <input
        *ngIf="!revealed"
        type="text"
        class="form-control sensitive-mask-input"
        [id]="inputId || null"
        [value]="maskedLabel"
        readonly
        [disabled]="disabled"
        [class.is-invalid]="invalid"
        (focus)="toggle()"
        (blur)="markTouched()"
        autocomplete="off">
      <input
        *ngIf="revealed"
        type="number"
        class="form-control"
        [id]="inputId || null"
        [ngModel]="value"
        (ngModelChange)="onNumberInput($event)"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="disabled"
        [readonly]="readonly"
        [class.is-invalid]="invalid"
        [attr.min]="min"
        [attr.step]="step"
        [placeholder]="placeholder"
        (blur)="markTouched()"
        autocomplete="off">
      <button
        type="button"
        class="btn btn-outline-secondary btn-eye-addon"
        (click)="toggle($event)"
        [disabled]="disabled"
        [attr.aria-label]="revealed ? 'Ocultar valor' : 'Visualizar valor'"
        [title]="revealed ? 'Ocultar valor' : 'Visualizar valor'">
        <i class="fas" [ngClass]="revealed ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
      </button>
    </div>
  </ng-template>
</div>
